import {Box} from '@mui/material'
import React from 'react'
import {getItemType, ItemType, ItemTypeEnum} from '../../../../../item/model/ItemType'

export const ItemTypeIcon = React.memo(({itemType}: { itemType: ItemType }) => {
    return <Box className={'item-type-icon ' + getItemTypeClass(itemType)}>
        {getItemType(itemType).icon}
    </Box>
    }
)

const getItemTypeClass = (type: ItemType) =>{
    switch(type.type){
        case ItemTypeEnum.MANUFACTURER:
            return 'manufacturer'
        case ItemTypeEnum.COMPANY:
            return 'company'
        case ItemTypeEnum.MULTISOURCE:
            return 'company'
        case ItemTypeEnum.SINGLESOURCE:
            return 'company'
        case ItemTypeEnum.ABSTRACT:
            return 'abstract'
        default:
            return ''
    }
}